import { Group } from "three";
export class ControllerHandObject {
    constructor() {
        this.group = new Group();
        this.joints = new Map();
        /** True while XR hand/joint data is available for this controller. */
        this.showHand = false;
        this.hasHandPose = false;
        this.group.matrixAutoUpdate = false;
        this.group.visible = false;
    }
}
